import React, { FC, useCallback, useState } from 'react';
import { ReportModel } from 'src/models';
import { DateRange } from '@material-ui/pickers';
import { ArrowIcon } from '../../../../components';
import { useLoading } from '../../../../providers';
import useGetReportDetails from '../hooks/useGetReportDetails';
import { MasterIbCommissionDialog } from './MasterIbCommissionsDialog';
import { DetailsModel } from '../MasteIBCommissionModel';
import { DataTable, ColumnConfig } from '../../DataTable';

interface Props {
  selectedDateRange: DateRange<Date>;
  partnerName?: string;
  translation: any;
  columns: ColumnConfig<ReportModel>[];
  selectedColumns: string[];
  rows: ReportModel[];
  onSelectColumns(columns: string[]): void;
}

export const PartnershipReports: FC<Props> = ({ translation, columns, rows, selectedDateRange, partnerName, onSelectColumns, selectedColumns }) => {
  const timestamp = new Date().getTime();
  const { setIsLoading } = useLoading();
  const [dialogTrigger, setDialogTrigger] = useState<boolean>(false);
  const [selectedPartnership, setSelectedPartnership] = useState<string>('');
  const [summaryData, setSummaryData] = useState<DetailsModel[]>([]);

  const getSummaryData = useGetReportDetails({
    dateRange: selectedDateRange,
    setSummaryData,
    setIsLoading,
  });

  const openDetailsDialog = useCallback(
    async (row: ReportModel) => {
      await getSummaryData(row.partnershipCode);
      setSelectedPartnership(row.partnershipCode);
      setDialogTrigger(true);
    },
    [getSummaryData],
  );

  return (
    <>
      <DataTable columns={columns} data={rows} translation={translation} columnSelect selectedColumns={selectedColumns} onSelectColumns={onSelectColumns} emptyMessage={translation.text_833} onRowAction={openDetailsDialog} rowActionIcon={<ArrowIcon />} />
      <MasterIbCommissionDialog
        key={`com_dialog${timestamp}`}
        title={`${translation.text_993} - ${partnerName} (${selectedPartnership})`}
        data={summaryData}
        translation={translation}
        open={dialogTrigger}
        handleCancel={() => setDialogTrigger(false)}
      />
    </>
  );
};
